import { Component, computed, input } from '@angular/core';
import { UserCouponProcedure } from '../../dtos/user-coupon.dto';

@Component({
  selector: 'app-user-coupon-procedure-item',
  templateUrl: './user-coupon-procedure-item.component.html',
  styleUrl: './user-coupon-procedure-item.component.scss',
  host: {
    class:
      'flex w-full justify-between items-center py-2 px-4 bg-background-50 rounded-lg',
  },
})
export class UserCouponProcedureItemComponent {
  procedure = input.required<UserCouponProcedure>();

  procedureName = computed(() => this.procedure().name);
  procedureDescription = computed(() => this.procedure().description);
  procedurePrice = computed(() => this.procedure().price);
  procedureCode = computed(() => this.procedure().code);
  isCompleted = computed(() => this.procedure().doneAt !== null);
}
